module.exports = __webpack_public_path__ + "images/topics/simple-machines/problem_solving_and_engineering.png";